import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';
import _ from "lodash";

import Title from "../components/Title";
import {config} from "../../config";
import Helmet from "react-helmet";
import createLink from "../../libs/createLink";
import {Link} from "react-router-dom";
import queryString from 'querystring';
import {fetchConfirmAccount} from "../../creators/user.confirmAccount";
import {LoadingBar} from "../components/Loader";
import {fetchCurrentUser} from "../../creators/currentUser";



class ConfirmAccount extends React.Component {
    constructor(props) {
        super(props);
        let search = this.props.location.search.replace("?","");
        this.actionToken = queryString.parse(search).actionToken;

        if(this.actionToken){
            this.props.fetchConfirmAccount({actionToken : this.actionToken}).then(response =>{
                this.props.fetchCurrentUser();
                _.delay(() =>{
                    this.props.history.push(createLink("userMe"));
                }, 2000);
            }).catch(e =>{console.log(e);});
        }
        else{
            this.props.history.push("/");
        }

    }

    componentWillUnmount() {
        if(this.actionToken){
            this.props.fetchCurrentUser();
        }
    }

   /* componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.userConfirmAccountInitialized){
            _.delay(() =>{
                this.props.fetchCurrentUser();
                this.props.history.push(createLink("userMe"));
            }, 2000);
        }
    }*/


    render() {
        return (
            <div id="confirm-email">
                <Helmet>
                    <title>{config.preTitle}Compte Confirmé{config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="card">
                        <div className="main-wrapper">
                            <Title heading={"heading-2"} display={"display-2"}>Confirmation de votre compte</Title>
                            {this.actionToken && !this.props.userConfirmAccountLoading && this.props.userConfirmAccountError && !this.props.userConfirmAccountError.error ? (
                                <div className="text">
                                    <p className={"color-success"}>Votre Compte est bien confirmé merci</p>
                                    <p>Redirection dans quelques secondes...</p>
                                </div>
                            ) : (!this.props.userConfirmAccountLoading ? (
                                <div className="text">
                                    <p className={"color-danger"}>{this.props.userConfirmAccountError.message ? this.props.userConfirmAccountError.message : "Votre code de validation est incorrecte "}</p>
                                </div>
                            ) : (<div className="text pb-8">
                                    <LoadingBar />
                                    </div>))}

                            <div className="text">
                                <p>Si vous avez le moindre problème n’hésitez pas à nous <Link to={createLink("contact")}>contacter</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    userConfirmAccount: state.userConfirmAccount.data,
    userConfirmAccountError: state.userConfirmAccount.error,
    userConfirmAccountInitialized: state.userConfirmAccount.initialized,
    userConfirmAccountLoading: state.userConfirmAccount.loading
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchConfirmAccount,
    fetchCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAccount);

